// Quem está na campanha, e em que ordem a aba Produtos mostra as coisas.

export const algumParticipa = (p, config) => (p.tamanhos
  ? p.tamanhos.some((t) => config?.pizza?.[p.id]?.[t.tamanho]?.participa)
  : !!config?.produtos?.[p.id]?.participa);

export const todosParticipam = (p, config) => (p.tamanhos
  ? p.tamanhos.every((t) => config?.pizza?.[p.id]?.[t.tamanho]?.participa)
  : !!config?.produtos?.[p.id]?.participa);

// Categorias e produtos na campanha primeiro; o resto segue a ordem do cardápio.
// A ordem vem da configuração SALVA: marcar um item não o faz pular de lugar
// debaixo do mouse — ele sobe na próxima vez que a página abrir ou salvar.
export function agruparOrdenado(produtos, categorias, busca, configSalva) {
  const termo = busca.trim().toLowerCase();
  const mapa = new Map((categorias || []).map((c) => [c, []]));
  for (const p of produtos || []) {
    if (termo && !String(p.name || "").toLowerCase().includes(termo)) continue;
    mapa.set(p.category, [...(mapa.get(p.category) || []), p]);
  }
  const naCampanha = (p) => (algumParticipa(p, configSalva) ? 0 : 1);
  return [...mapa.entries()]
    .filter(([, lista]) => lista.length > 0)
    .map(([categoria, lista]) => [categoria, [...lista].sort((a, b) => naCampanha(a) - naCampanha(b))])
    .sort(([, a], [, b]) => naCampanha(a[0]) - naCampanha(b[0]));
}

export function marcarProdutos(config, lista, marcar) {
  const produtos = { ...config.produtos };
  const pizza = { ...config.pizza };
  for (const p of lista) {
    if (p.tamanhos) {
      pizza[p.id] = { ...(pizza[p.id] || {}) };
      for (const t of p.tamanhos) pizza[p.id][t.tamanho] = { ...(pizza[p.id][t.tamanho] || {}), participa: marcar };
    } else {
      produtos[p.id] = { ...(produtos[p.id] || {}), participa: marcar };
    }
  }
  return { ...config, produtos, pizza };
}
